<template>
  <SfTabs :open-tab="1">
    <SfTab title="Персональные данные">
      <p class="message">
        Вы можете изменить свои данные в любой момент
      </p>
      <div class="form">
        <SfInput
          v-model="name"
          name="name"
          label="Имя"
          required
          class="form__element form__element--half"
        />
        <SfInput
          v-model="phone"
          name="phone"
          label="Телефон"
          required
          class="form__element form__element--half form__element--half-even"
          v-mask="'+998#########'"
        />
        <SfInput
          v-model="email"
          type="email"
          name="email"
          label="Email"
          required
          class="form__element"
        />
        <SfButton class="form__button classic-button" @click="updatePersonal"
          >Сохранить
        </SfButton>
      </div>
      <p class="notice">
        Используя наш сайт вы соглашаетесь с нашей
        <router-link :to="{ name: 'page', params: { slug: 'privacy' } }">
          политикой конфиденциальности и обработки данных.
        </router-link>
      </p>
    </SfTab>
    <SfTab title="Смена пароля">
      <p class="message">
        Если хотите сменить пароль для данного аккаунта, введите следующие данные:<br />Ваш нынешний email:
        <span class="message__label">{{ account.email }}</span>
      </p>
      <div class="form">
        <SfInput
          v-model="old_password"
          type="password"
          name="old_password"
          label="Актуальный пароль"
          required
          class="form__element"
        />
        <SfInput
          v-model="password"
          type="password"
          name="password"
          label="Новый пароль"
          required
          class="form__element form__element--half"
        />
        <SfInput
          v-model="password_confirmation"
          type="password"
          name="password_confirmation"
          label="Повторить пароль"
          required
          class="form__element form__element--half form__element--half-even"
        />
        <SfButton class="form__button classic-button" @click="updatePassword"
          >Обновить пароль
        </SfButton>
      </div>
    </SfTab>
  </SfTabs>
</template>
<script>
import { SfTabs, SfInput, SfButton } from "@storefront-ui/vue";
export default {
  name: "PersonalDetails",
  components: {
    SfTabs,
    SfInput,
    SfButton,
  },
  props: {
    account: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      name: "",
      phone: "",
      email: "",
      old_password: "",
      password: "",
      password_confirmation: "",
    };
  },
  watch: {
    account: {
      handler(value) {
        this.name = value.name;
        this.phone = value.phone;
        this.email = value.email;
      },
      immediate: true,
    },
  },
  methods: {
    updatePersonal() {
      const personal = {
        name: this.name,
        phone: this.phone,
        email: this.email,
      };
      this.$emit("update:personal", personal);
    },
    updatePassword() {
      const password = {
        old_password: this.old_password,
        password: this.password,
        password_confirmation: this.password_confirmation
      };
      this.$emit("update:password", password);
      this.old_password = ''
      this.password = ''
      this.password_confirmation = ''
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/vue/styles";
.form {
  @include for-desktop {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &__element {
    margin: 0 0 var(--spacer-lg) 0;
    @include for-desktop {
      flex: 0 0 100%;
    }
    &--half {
      @include for-desktop {
        flex: 1 1 50%;
      }
      &-even {
        @include for-desktop {
          padding: 0 0 0 var(--spacer-lg);
        }
      }
    }
  }
  &__button {
    --button-width: 100%;
    @include for-desktop {
      --button-width: 17.5rem;
    }
  }
}
.message {
  margin: 0 0 var(--spacer-xl) 0;
  color: var(--c-dark-variant);
}
.notice {
  margin: var(--spacer-base) 0 0 0;
  font-size: var(--font-size--sm);
}
a {
  color: var(--c-primary);
  text-decoration: none;
  &:hover {
    color: var(--c-text);
  }
}
</style>